import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { ExcelService, OutBoxMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import {
  CustomResultOfGetOrganizationTransactionByIdDto,
  GetOrganizationTransactionByIdDto,
  TransactionsWithPaginationDto,
  TransactionsWithPaginationItemDto,
} from '../../../core/api/models';
import { CreateTransactionsExcelDialogComponent } from '../organization-transactions/create-transactions-excel/create-transactions-excel-dialog.component';
import { OrganizationTransactionsComponent } from '../organization-transactions/organization-transactions.component';
import { OrganizationTransactionsService } from './../../../core/api/services/organization-transactions.service';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ResellersOrganizationTransactionsDetailComponent } from './resellers-organization-transactions-detail/resellers-organization-transactions-detail.component';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';

@Component({
    selector: 'app-reseller-organization-transactions',
    templateUrl: './reseller-organization-transactions.component.html',
    imports: [BaseIndexModule, ResellersOrganizationTransactionsDetailComponent, TextPopoverDirective]
})
export class ResellerOrganizationTransactionsComponent
  extends OrganizationTransactionsComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.organizationTransactions;
  protected currentService = inject(OrganizationTransactionsService);
  auditApiMethodName: string = this.currentService.organizationTransactionsGetOrganizationTransactionsAudit.name;
  modelWithPagination$: Observable<TransactionsWithPaginationDto>;
  items$: Observable<Array<TransactionsWithPaginationItemDto>>;
  detailModel: GetOrganizationTransactionByIdDto;
  isShowDetail: boolean;
  fontSize: AppFontSize = 'sm';

  //#endregion

  constructor(
    public outBoxMessagesService: OutBoxMessagesService,
    protected excelFileService: ExcelService,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super(outBoxMessagesService, excelFileService,tabsDynamicComponent);
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.title =
      'pages.organizationTransactions.resellerTransactionTitle';
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showAuditBtn = false;
  }

  configTableColumns() {
    try {
      super.configTableColumns();
      this.tableColumns = this.tableColumns.filter(
        (column) =>
          column.name !== 'packageId' && column.name !== 'packageTitle'
      );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<TransactionsWithPaginationDto> {
    return this.currentService
      .organizationTransactionsGetResellerOrganizationTransactionWithPagination(
        { body: this.getBaseModelWithPaginationParams() }
      )
      .pipe(
        tap((items: any) => {
          this.calculateTotalSum(items?.data?.items);
          // this.getAllItems(items.items);
        })
      );
  }

  onDetail(id: any, setFiltersAndUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id
      );
    }
    this.baseGetByIdApi(id);
  }

  baseGetByIdApi(id: any): void {
    this.unSubs();
    this.currentService
      .organizationTransactionsGetOrganizationTransactionById({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res: CustomResultOfGetOrganizationTransactionByIdDto) => {
        this.detailModel = res.data;
        this.isShowDetail = true;
      });
  }

  ResellerOrganizationsTransactionsExcelReportApi() {
    this.excelFileService
      .excelCreateResellerTransactionsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}resellerTransactionsExcel`,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
            methodName: 'excelCreateResellerTransactionsExcelPost',
          };

          const modalResult = this.dialogService.openModal({
            component: CreateTransactionsExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  onCloseDetail() {
    this.isShowDetail = false;
  }

  //#endregion

  onExcelReport() {
    this.ResellerOrganizationsTransactionsExcelReportApi();
  }
}
